
import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const setFetching = (flag) => ({
  type: types.FETCHING,
  flag,
});

const setError = (flag) => ({
  type: types.SET_ERROR,
  flag,
});

const setSelectedMetric = (payload) => ({
  type: types.SET_SELECTED_METRIC,
  payload,
});

const setSensitivityData = (payload) => ({
  type: types.SET_SENSITIVITY_METRIC_CONFIG_LIST,
  payload,
});

const setLogsError = (flag) => ({
  type: types.SET_LOGS_ERROR,
  flag,
});

const setSensitivityLogsFetching = (flag) => {
  return ({
    type: types.SENSITIVITY_LOGS_FETCHING,
    flag,
  })};

const fetchSensitivityLogs = () => ({
  type: types.FETCH_SENSITIVITY_LOGS
});

const setSensitivityLogs = (payload) => ({
  type: types.SET_SENSITIVITY_LOGS,
  payload,
});

const setCurrentConfig = (payload) => ({
  type: types.SET_CURRENT_CONFIG,
  payload,
});

const updateCurrentConfig = (payload) => ({
  type: types.UPDATE_CURRENT_CONFIG,
  payload,
});

const saveSensitivityData = (payload, closePopup) => ({
  type: types.SAVE_SENSITIVITY_DATA,
  payload,
  closePopup
});

const setCurrentConfigErrorMsg = (errorMsg) => {
  return ({
    type: types.SET_SENSITIVITY_CONFIG_ERROR_MSG,
    errorMsg
  })};

export {
  init,
  fetching,
  fetchData,
  setFetching,
  setError,
  setSensitivityData,
  saveSensitivityData,
  setSelectedMetric,
  setSensitivityLogs,
  setCurrentConfig,
  updateCurrentConfig,
  setCurrentConfigErrorMsg,
  fetchSensitivityLogs,
  setSensitivityLogsFetching,
  setLogsError
};
